import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContentService, ServicePathProviderService } from '@blk/cwp-ng-framework';
import { WebUserDataConstants } from '@ddt-web/domain';
import { LocalStorageKey } from '@ddt-web/generic-utils';
import { Observable, of, ReplaySubject } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import { UserProfile } from '../models/user-profile';

@Injectable({
	providedIn: 'root'
})
export class UserDataService {
	private userDataSubject: ReplaySubject<UserProfile> = new ReplaySubject(1);
	private userDataRequested = false;

	constructor(
		private http: HttpClient,
		private servicePathProvider: ServicePathProviderService,
		private contentService: ContentService) {
	}

	public getUserProfile(): Observable<UserProfile> {
		const userServiceUrl: string = this.servicePathProvider.getServicePath('api-gateway') + WebUserDataConstants.TOOL_SERVICE_URL.GET_USER;
		if (!this.userDataRequested) {
			this.userDataRequested = true;
			this.http
				.get(userServiceUrl)
				.pipe(
					take(1),
					catchError(error => {
						console.error('An error occurred while updating the users profile', error);
						this.userDataRequested = false;
						return of(error);
					})
				)
				.subscribe(this.userDataSubject);
		}
		return this.userDataSubject.pipe(
			map((userProfile: UserProfile) => {
				if (userProfile.internalUser) {
					const partnerOverride = localStorage.getItem(LocalStorageKey.SsoInitiatedFrom);
					if (partnerOverride) {
						userProfile.userAttributes.ssoInitiatedFrom = partnerOverride;
					}
				}
				return userProfile;
			})
		);
	}

	public isInternalUser$(): Observable<boolean> {
		return this.getUserProfile().pipe(
			map((userProfile: UserProfile) => {
				return userProfile.internalUser;
			})
		);
	}

	public isPilotUser$(): Observable<boolean> {
		return this.getUserProfile().pipe(
			map((userProfile: UserProfile) => {
				return (userProfile.internalUser && localStorage.getItem(LocalStorageKey.EnableNewPortfolioEditor) === 'true') ||
					!!this.contentService.get('PORTFOLIO_EDITOR_PILOT', null);
			})
		);
	}

	public isAladdinuUser$(): Observable<boolean> {
		return this.getUserProfile().pipe(
			map((userProfile: UserProfile) => {
				return !!userProfile?.userAttributes?.aladdinUniv;
			})
		);
	}
}
